import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { type User } from "@vidario/domain";

import { useVidarioClient } from "../client";

/** Admin-only: assign a user's total search quota. Invalidates the user
 * directory (new remaining count) and `me` (in case the admin adjusted a
 * value the current session reads). */
export function useSetUserQuota(): UseMutationResult<
  User,
  Error,
  { id: string; searchQuota: number }
> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input) => client.setUserQuota(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["users"] });
      qc.invalidateQueries({ queryKey: ["me"] });
    },
  });
}
